const omnihubElem = document.getElementById("omni-hub-stock");

if (omnihubElem) {
  const intervalId = setInterval(() => {
    const elements = omnihubElem.getElementsByTagName("th");

    if (elements.length > 0) {
      for (const e of elements) {
        e.innerHTML = e.innerHTML.replace(/^NAILS INC NAGOYA/, "");
        e.innerHTML = e.innerHTML.replace(/^NAILS INC/, "");
      }
      // ポーリングを停止
      clearInterval(intervalId);
    }
  }, 500);  // 500msごとにチェック

} else {
  console.warn("Element with ID 'omni-hub-stock' not found.");
}

document.addEventListener('DOMContentLoaded', function () {
  const productAreas = document.querySelectorAll('.product-area');

  productAreas.forEach(function (productArea) {
    const mobileThumbLinks = productArea.querySelectorAll(
      '.product-area__mobile-thumbs .theme-gallery-thumb a'
    );

    const viewport = productArea.querySelector('.theme-viewport.swiper-container');

    if (!mobileThumbLinks.length || !viewport) return;

    function updateActiveThumbByIndex(activeIndex) {
      mobileThumbLinks.forEach(function (link, index) {
        link.classList.toggle('thumb-active', index === activeIndex);
      });
    }

    function updateActiveThumbByMediaId(mediaId) {
      if (!mediaId) return;

      mobileThumbLinks.forEach(function (link) {
        const thumb = link.closest('.theme-gallery-thumb');
        const thumbMediaId = thumb ? thumb.dataset.mediaId : null;

        link.classList.toggle('thumb-active', thumbMediaId === mediaId);
      });
    }

    function updateActiveThumbFromCurrentSlide() {
      const activeSlide = viewport.querySelector('.swiper-slide-active');
      const activeMediaId = activeSlide ? activeSlide.dataset.mediaId : null;

      if (activeMediaId) {
        updateActiveThumbByMediaId(activeMediaId);
        return;
      }

      const swiper = viewport.swiper;

      if (swiper) {
        const activeIndex =
          typeof swiper.realIndex === 'number' ? swiper.realIndex : swiper.activeIndex;

        updateActiveThumbByIndex(activeIndex);
      }
    }

    mobileThumbLinks.forEach(function (link, index) {
      link.addEventListener('click', function (event) {
        event.preventDefault();

        const swiper = viewport.swiper;

        if (swiper && typeof swiper.slideTo === 'function') {
          swiper.slideTo(index);
          updateActiveThumbByIndex(index);

          setTimeout(updateActiveThumbFromCurrentSlide, 300);
        }
      });
    });

    const waitForSwiper = setInterval(function () {
      const swiper = viewport.swiper;

      if (!swiper) return;

      clearInterval(waitForSwiper);

      if (typeof swiper.on === 'function') {
        swiper.on('slideChange', function () {
          setTimeout(updateActiveThumbFromCurrentSlide, 0);
          setTimeout(updateActiveThumbFromCurrentSlide, 300);
        });

        swiper.on('transitionEnd', function () {
          updateActiveThumbFromCurrentSlide();
        });

        swiper.on('touchEnd', function () {
          setTimeout(updateActiveThumbFromCurrentSlide, 300);
        });
      }

      updateActiveThumbFromCurrentSlide();
    }, 100);
  });
});